import { forwardRef } from "react";

import { ButtonProps } from "./button.type";
import BaseButton from "./BaseButton";
import Icon from "../Icon/Icon";
import { oldIconMapper } from "./iconMapper.old";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      id,
      disabled,
      text,
      children,
      paddingX = 9,
      variant = "primary",
      icon,
      iconWeight = "regular",
      iconAlignment = "left",
      iconColor,
      iconWidth,
      iconHeight,
      analytics,
      ...rest
    },
    ref
  ) => {
    const mappedIcon = icon ? oldIconMapper[icon] ?? icon : undefined;
    const eventName = analytics ? "click" : undefined;
    const eventCategory = analytics
      ? analytics.eventCategory || "button"
      : undefined;

    const iconColorOverload =
      variant !== "button" && typeof iconColor === "undefined"
        ? "currentColor"
        : undefined;

    return (
      <BaseButton
        id={id}
        disabled={disabled}
        variant={variant}
        paddingX={paddingX}
        ref={ref}
        data-en={eventName}
        data-ec={eventCategory}
        data-el={analytics?.eventLabel}
        data-ea={analytics?.eventAction}
        data-es={analytics?.eventSection}
        data-et={analytics?.eventType}
        data-ev={analytics?.eventValue}
        {...rest}
      >
        {iconAlignment === "left" && mappedIcon !== undefined && (
          <Icon
            name={mappedIcon?.name || icon}
            weight={mappedIcon?.weight || iconWeight}
            color={iconColorOverload}
            mr={2}
            width={iconWidth || mappedIcon?.width}
            height={iconHeight || mappedIcon?.height}
          />
        )}
        {text}
        {children}
        {iconAlignment === "right" && mappedIcon !== undefined && (
          <Icon
            name={mappedIcon?.name || icon}
            weight={mappedIcon?.weight || iconWeight}
            color={iconColorOverload}
            ml={6}
            width={iconWidth || mappedIcon?.width}
            height={iconHeight || mappedIcon?.height}
          />
        )}
      </BaseButton>
    );
  }
);

export default Button;
